
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 281.85 247.81","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M232.15 87.32a4.5 4.5 0 00-4.5 4.5v107H49V20.15h183.15a4.5 4.5 0 100-9H44.5a4.49 4.49 0 00-4.5 4.5v35.5H4.5a4.5 4.5 0 00-4.5 4.5v187.66a4.49 4.49 0 004.5 4.5h187.65a4.49 4.49 0 004.5-4.5v-35.5h35.5a4.5 4.5 0 004.5-4.5V91.82a4.49 4.49 0 00-4.5-4.5zm-44.5 151.49H9V60.15h31v143.16a4.5 4.5 0 004.5 4.5h143.15z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M280.53 1.32a4.5 4.5 0 00-6.37 0L136 139.53l-30.06-30a4.5 4.5 0 00-6.36 6.36l33.24 33.24a4.49 4.49 0 006.36 0L280.53 7.68a4.49 4.49 0 000-6.36z"}})])])])
          )
        }
      }
    